var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20.625C8.385 20.625 7.875 20.115 7.875 19.5V15.75C7.875 11.4 11.415 7.875 15.75 7.875H19.5C20.115 7.875 20.625 8.385 20.625 9C20.625 9.615 20.115 10.125 19.5 10.125H15.75C12.645 10.125 10.125 12.645 10.125 15.75V19.5C10.125 20.115 9.615 20.625 9 20.625Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 20.625C38.385 20.625 37.875 20.115 37.875 19.5V15.75C37.875 12.645 35.355 10.125 32.25 10.125H28.5C27.885 10.125 27.375 9.615 27.375 9C27.375 8.385 27.885 7.875 28.5 7.875H32.25C36.585 7.875 40.125 11.4 40.125 15.75V19.5C40.125 20.115 39.615 20.625 39 20.625Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 40.125H30C29.385 40.125 28.875 39.615 28.875 39C28.875 38.385 29.385 37.875 30 37.875H32.25C35.355 37.875 37.875 35.355 37.875 32.25V30C37.875 29.385 38.385 28.875 39 28.875C39.615 28.875 40.125 29.385 40.125 30V32.25C40.125 36.6 36.585 40.125 32.25 40.125Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 40.125H15.75C11.415 40.125 7.875 36.6 7.875 32.25V28.5C7.875 27.885 8.385 27.375 9 27.375C9.615 27.375 10.125 27.885 10.125 28.5V32.25C10.125 35.355 12.645 37.875 15.75 37.875H19.5C20.115 37.875 20.625 38.385 20.625 39C20.625 39.615 20.115 40.125 19.5 40.125Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7497 23.0697C21.1356 23.0697 23.0697 21.1356 23.0697 18.7497C23.0697 16.3638 21.1356 14.4297 18.7497 14.4297C16.3638 14.4297 14.4297 16.3638 14.4297 18.7497C14.4297 21.1356 16.3638 23.0697 18.7497 23.0697Z",
    fill: "#111827"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2497 33.5697C18.8071 33.5697 20.0697 32.3071 20.0697 30.7497C20.0697 29.1922 18.8071 27.9297 17.2497 27.9297C15.6922 27.9297 14.4297 29.1922 14.4297 30.7497C14.4297 32.3071 15.6922 33.5697 17.2497 33.5697Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7497 20.0697C32.3071 20.0697 33.5697 18.8071 33.5697 17.2497C33.5697 15.6922 32.3071 14.4297 30.7497 14.4297C29.1922 14.4297 27.9297 15.6922 27.9297 17.2497C27.9297 18.8071 29.1922 20.0697 30.7497 20.0697Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2497 33.5697C31.6356 33.5697 33.5697 31.6356 33.5697 29.2497C33.5697 26.8638 31.6356 24.9297 29.2497 24.9297C26.8638 24.9297 24.9297 26.8638 24.9297 29.2497C24.9297 31.6356 26.8638 33.5697 29.2497 33.5697Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanning);
export default __webpack_public_path__ + "static/media/scanning.adbfc6514a2aec05ebc275a315434d59.svg";
export { ForwardRef as ReactComponent };